import { MessageBox } from 'element-ui'
const DmMessageBox = MessageBox
export default DmMessageBox

